import React, { Component } from 'react';
import { Modal, DatePicker, Select, Input, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import SearchRetrieve from '../../common/SearchRetrieve.new';

const { Option } = Select;
const { TextArea } = Input;
const dateFormat = "YYYY-MM-DD";

class LoseRecord extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        firstRender: true,
        renderHospital: true,
        renderDepartment: true,
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    timer = null;

    show = (parentRecord, record) => {
        const { userId } = parentRecord;
        const params = {
            userId,
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
            firstRender: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            invOptions: [],
            hospitalOptions: [],
            departmentOptions: [],
        });
    }

    // 校验value是否存在，且是options中的一项
    validateValueInOptions = (value, name, list) => {
        if (value) {
            const isExist = list.some(item => item.value == value);
            if (!isExist) {
                message.warning(`请选择正确的${name}`);
                return true;
            }
        } else {
            message.warning(`请选择${name}`);
            return true;
        }
        return false;
    }

    submit = () => {
        const {
            isEdit,
            params: {
                userId,
                hospitalDepartmentProjectLoseId,
                loseTime,
                loseType,
                loseReason,
                remark,
                projectId,
                hospitalMainId,
                departmentId,
                hospitalId,
            },
            invOptions = [],
            hospitalOptions = [],
            departmentOptions = [],
        } = this.state;
        if (!loseTime) {
            message.warning('请选择丢失时间');
            return;
        }
        if (!loseType) {
            message.warning('请选择丢失类型');
            return;
        } else if (loseType == 'LOSE_INVESTIGATION') {
            if (this.validateValueInOptions(projectId, '项目简称', invOptions)) {
                return;
            }
        } else {
            // if (this.validateValueInOptions(hospitalMainId, '医院', hospitalOptions)) {
            //     return;
            // }
            if (loseType == 'LOSE_DEPARTMENT') {
                if (this.validateValueInOptions(departmentId, '科室', departmentOptions)) {
                    return;
                }
            }
        }
        if (!loseReason) {
            message.warning('请选择丢失原因');
            return;
        }
        if (!remark) {
            message.warning('请填写备注');
            return;
        }

        let url;
        let newParams = {
            userId,
            hospitalDepartmentProjectLoseId,
            loseTime: loseTime ? loseTime.slice(0, 10) : '',
            loseType,
            loseReason,
            remark,
            projectId,
            departmentId,
            hospitalId: hospitalId? hospitalId: hospitalMainId,
        };
        if (isEdit) {
            url = API_URL.user.modifyHospitalDepartmentProjectLose;
        } else {
            url = API_URL.user.addHospitalDepartmentProjectLose;
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: newParams,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;

        const clearParams = {};
        if (key == 'loseType') {
            params.projectId = '';
            params.hospitalId = '';
            params.departmentId = '';
            clearParams.invOptions = [];
            clearParams.hospitalOptions = [];
            clearParams.departmentOptions = [];
            this.setState({
                renderHospital: false,
                renderDepartment: false,
            }, () => {
                this.setState({
                    renderHospital: true,
                    renderDepartment: true,
                });
            });
        }else if ( key == 'courtyardArea'){
            params.hospitalId = value;
        }
        this.setState({
            params,
            ...clearParams,
        });
    }

    handleHighSearchInputFocus = () => {
        const { params: { hospitalId } } = this.state;
        if (!hospitalId) {
            message.warning('请先选择医院');
            return false;
        }
        return true;
    }

    handleHospitalChange = ( options, idName, optionsName) => {
        const { params, params: { loseType }, isEdit, firstRender } = this.state;
        params[idName] = options.value;
        params.hospitalName = options.text;
        params.courtyardArea = undefined;
        if (idName == 'hospitalMainId') {
            // 第一次change医院时，不清除科室的信息（处理编辑回显问题）
            if (loseType == 'LOSE_DEPARTMENT' && !firstRender) {
                params['departmentId'] = '';
                this.setState({
                    departmentOptions: [],
                    renderDepartment: false,
                }, () => {
                    this.setState({ renderDepartment: true })
                });
            }
            if (isEdit && firstRender && options.length) {
                this.setState({ firstRender: false });
            }
        }
        this.setState({
            params,
            [optionsName]: options,
        },() => this.queryCourtyardAreaList());
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { params, params: { loseType }, isEdit, firstRender } = this.state;
        params[idName] = id;
        this.setState({
            params,
            [optionsName]: options,
        });
    }

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { params: { hospitalMainId } } = this.state;
            if (hospitalMainId){
                const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    const needCourtyardArea = datas && datas[0].courtyardArea;
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                }
            };
            $.sendRequest(options);
            }
        }, 300);
    }

    getContent = () => {
        const { isEdit, params, visible, renderHospital, renderDepartment, CourtyardAreaList, needCourtyardArea } = this.state;
        const {
            loseTime,
            projectId,
            investigationName,
            hospitalMainId,
            hospitalName,
            departmentId,
            departmentName,
            loseType,
            loseReason,
            remark,
            hospitalId,
            courtyardArea,
        } = params;
        const newLoseTime = loseTime ? moment(loseTime) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}丢失时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={newLoseTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "loseTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}丢失类型:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={loseType || undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'loseType')}
                        >
                            <Option value="LOSE_INVESTIGATION">项目丢失</Option>
                            <Option value="LOSE_HOSPITAL">医院丢失</Option>
                            <Option value="LOSE_DEPARTMENT">科室丢失</Option>
                        </Select>
                    </div>
                </li>
                {
                    loseType == 'LOSE_INVESTIGATION' && visible &&
                    <li className="modal-item">
                        <div className="item-left">{asterisk}项目简称:</div>
                        <div className="item-right">
                            <HighSearchInput
                                isEdit={isEdit}
                                keyword='investigationName'
                                style={{ width: 240 }}
                                placeholder="输入项目简称或编号自动检索"
                                params={{limit: 20}}
                                url={API_URL.investigation.queryInvestigationByName}
                                initValue={{ key: projectId, label: investigationName }}
                                config={{ id: 'investigationId', name: 'investigationName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'projectId', 'invOptions')}
                            />
                        </div>
                    </li>
                }
                {
                    // (loseType == 'LOSE_HOSPITAL' || loseType == 'LOSE_DEPARTMENT') && renderHospital && visible &&
                    <li className="modal-item">
                        <div className="item-left">{asterisk}医院:</div>
                        <div className="item-right">
                            <SearchRetrieve
                                isEdit={isEdit}
                                keyword='hospitalName'
                                style={{ width: 182 }}
                                params={{ limit: 10, offset: 1 }}
                                placeholder="输入医院名称自动检索"
                                value={hospitalName}
                                url={API_URL.hospital.queryHospitalMainList}
                                config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                                onChange={options => this.handleHospitalChange( options, 'hospitalMainId' )}
                            />
                        </div>
                    </li>
                }
                <li className="modal-item">
                        <div className="item-left">{asterisk}院区:</div>
                        <div className="item-right">
                            <Select
                                style={{ width: 182 }}
                                placeholder="请输入"
                                disabled={ !needCourtyardArea || !hospitalMainId } 
                                value={courtyardArea}
                                onChange={value => this.handleSelectChange(value, 'courtyardArea')}
                            >
                                {CourtyardAreaOptions}
                            </Select>
                        </div>
                    </li>
                {
                    loseType == 'LOSE_DEPARTMENT' && renderDepartment && visible &&
                    <li className="modal-item">
                        <div className="item-left">{asterisk}科室:</div>
                        <div className="item-right">
                            <HighSearchInput
                                isEdit={isEdit}
                                keyword='hospitalDepName'
                                style={{ width: 182 }}
                                placeholder="输入科室名称自动检索"
                                params={{hospitalId: hospitalId ? hospitalId : hospitalMainId}}
                                url={API_URL.hospital.queryDepWhenAddDoctor}
                                initValue={{ key: departmentId, label: departmentName }}
                                config={{ id: 'departmentId', name: 'departmentLocalName' }}
                                onFocus={this.handleHighSearchInputFocus}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'departmentId', 'departmentOptions')}
                            />
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left">{asterisk}丢失原因:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={loseReason || undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'loseReason')}
                        >
                            <Option value="SERIOUS_COMPLAINTS">严重投诉</Option>
                            <Option value="UNTIMELY_HANDLING">处理不及时</Option>
                            <Option value="NEGATIVE_ATTITUDE">态度不积极</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}备注:</div>
                    <div className="item-right">
                        <TextArea
                            rows={4}
                            placeholder="请填写"
                            value={remark}
                            style={{ width: 240 }}
                            onChange={e => this.handleInputChange(e, 'remark')}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}医院科室或项目丢失`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default LoseRecord;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/LoseRecord.js